import React, { FunctionComponent } from 'react';
import * as styles from './DefinitionList.style';

export interface DefinitionListProps {
  items: {
    term: string,
    description: string,
  }[],
}

const DefinitionList: FunctionComponent<DefinitionListProps> = ({ items }) => (
  <dl css={styles.base}>
    {items.map((item) => (
      <div
        css={styles.item}
        key={`${item.term}-${item.description}`}
        data-ref="definition-list-item"
      >
        <dt
          css={styles.term}
          data-ref="definition-list-term"
        >
          {item.term}
        </dt>
        <dd
          css={styles.description}
          data-ref="definition-list-description"
        >
          {item.description}
        </dd>
      </div>
    ))}
  </dl>
);

export default DefinitionList;
